import { TextField, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Snackbar, Alert } from "@mui/material";
import { Close } from "@mui/icons-material";
import React, { useState, useContext } from "react";
import "./OTPForm.css";
import { validateOTP } from "../../../api/forgetpasswordApi/forgetpasswordApi";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext"; 
import ChangePWwithEmailForm from "../changePWwithEmailForm/ChangePWwithEmailForm"; // Import Change Password Form

export const OTPForm = ({ open, handleClose, email }) => {
  const [otp, setOTP] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openChangePW, setOpenChangePW] = useState(false); // State for Change PW Popup
  const navigate = useNavigate();
  const { login } = useContext(AuthContext); 

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!otp) {
      setError("OTP is required");
      return;
    }

    setLoading(true);

    try {
      const response = await validateOTP(otp.trim(), email);
      // console.log("OTP validated successfully:", response);

      if (response.token) {
        localStorage.setItem("token", response.token);
        login(response.token);
      }

      setAlertSeverity("success");
      setAlertMessage("OTP validated successfully!");
      setOpenSnackbar(true);
      handleClose(); // Close OTP popup

      // Open Change Password popup
      setOpenChangePW(true);

    } catch (error) {
      console.error("Error validating OTP:", error);
      setAlertSeverity("error");
      setAlertMessage(error.response ? error.response.data.message : "Invalid OTP. Please try again.");
      setError("Invalid OTP. Please try again.");
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="OTPForm">
      <Dialog open={open} onClose={handleClose} className="OTPFormDialog">
        <DialogTitle className="OTPFormHeader">
          Check Your Email !
          <p className="OTPForm-p">OTP code will expire in 10 minutes</p>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "#6E0506",
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <form className="OTPForm-Form" onSubmit={handleSubmit}>
            <TextField
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOTP(e.target.value)}
              className="OTPFormInputField"
              fullWidth
              error={!!error}
              helperText={error}
              margin="normal"
              disabled={loading}
            />
            <DialogActions>
              <Button
                type="submit"
                variant="contained"
                sx={{
                  backgroundColor: "#6E0506 !important",
                  "&:hover": { backgroundColor: "#bf282a !important" },
                  color: "#fff",
                }}
                disabled={loading}
              >
                {loading ? "Validating..." : "Send"}
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>

      {/* Snackbar for alerts */}
      <Snackbar open={openSnackbar} autoHideDuration={4000} onClose={() => setOpenSnackbar(false)}>
        <Alert onClose={() => setOpenSnackbar(false)} severity={alertSeverity} sx={{ width: "100%" }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      {/* Open Change Password Form if OTP is valid */}
      <ChangePWwithEmailForm
        open={openChangePW}
        handleClose={() => {
          setOpenChangePW(false);
          navigate("/forget-password"); // Navigate to profile after password change
        }}
      />
    </div>
  );
};
